shadow$provide[348] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, MemoScreen:{enumerable:true, get:function() {
  return MemoScreen;
}}});
var require$three = require("three");
var require$_DOT__SLASH_screen_DOT_js = require("./screen.js");
class MemoScreen extends require$_DOT__SLASH_screen_DOT_js.Screen {
  constructor(renderer, shaders, options) {
    const {items, width, height, depth, stpq} = options;
    const inv = x => 1 / Math.max(1, x);
    const inv1 = x => 1 / Math.max(1, x - 1);
    const uniforms = {remapUVScale:{type:"v2", value:new require$three.Vector2(items * width, height * depth),}, remapModulus:{type:"v2", value:new require$three.Vector2(items, height),}, remapModulusInv:{type:"v2", value:new require$three.Vector2(inv(items), inv(height)),}, remapSTPQScale:{type:"v4", value:new require$three.Vector4(inv1(width), inv1(height), inv1(depth), inv1(items)),},};
    const map = shaders.shader();
    map.pipe("screen.map.xyzw", uniforms);
    if (options.map != null) {
      if (stpq) {
        map.pipe("screen.map.stpq", uniforms);
      }
      map.pipe(options.map);
    }
    super(renderer, shaders, {map, linear:true});
    this.memo = options;
    this.uniforms = uniforms;
    for (const object of Array.from(this.renders)) {
      object.transparent = false;
    }
  }
  cover(width, height, depth, items) {
    if (width == null) {
      ({width} = this.memo);
    }
    if (height == null) {
      ({height} = this.memo);
    }
    if (depth == null) {
      ({depth} = this.memo);
    }
    if (items == null) {
      ({items} = this.memo);
    }
    const inv1 = x => 1 / Math.max(1, x - 1);
    this.uniforms.remapSTPQScale.value.set(inv1(width), inv1(height), inv1(depth), inv1(items));
    const x = width / this.memo.width;
    let y = depth / this.memo.depth;
    if (this.memo.depth === 1) {
      y = height / this.memo.height;
    }
    return this.geometry.cover(x, y);
  }
}

};